import React from 'react';
import { useIntl } from 'react-intl';

import { Link } from 'gatsby';
import { ArrowRight } from '@carbon/icons-react';

import * as css from './ProductsGrid.module.scss';

export function ProductsGrid() {
    const { formatMessage, locale } = useIntl();
    const cells = {
        pool: (
            <Link to={`/${locale}/braiins-pool/about`} className={css.cellPool}>
                <div className={css.cellContent}>
                    <div className={css.title} children={formatMessage({ defaultMessage: 'Braiins Pool' })} />
                    <ArrowRight size={24} className={css.icon} />
                </div>
            </Link>
        ),
        bos: (
            <Link to={`/${locale}/braiins-os/about`} className={css.cellBos}>
                <div className={css.cellContent}>
                    <div className={css.title} children={formatMessage({ defaultMessage: 'Braiins OS' })} />
                    <ArrowRight size={24} className={css.icon} />
                </div>
            </Link>
        ),
        proxy: (
            <Link to={`/${locale}/farm-proxy/about`} className={css.cellProxy}>
                <div className={css.cellContent}>
                    <div className={css.title} children={formatMessage({ defaultMessage: 'Braiins Proxy' })} />
                    <ArrowRight size={24} className={css.icon} />
                </div>
            </Link>
        ),
        monitor: (
            <Link to={`/${locale}/farm-monitor/about`} className={css.cellMonitor}>
                <div className={css.cellContent}>
                    <div className={css.title} children={formatMessage({ defaultMessage: 'Braiins Farm Monitor' })} />
                    <ArrowRight size={24} className={css.icon} />
                </div>
            </Link>
        ),
        insights: (
            <Link to={`/${locale}/mining-insights/about`} className={css.cellInsights}>
                <div className={css.cellContent}>
                    <div className={css.title} children={formatMessage({ defaultMessage: 'Braiins Insights' })} />
                    <ArrowRight size={24} className={css.icon} />
                </div>
            </Link>
        ),
    };

    return (
        <section className={css.grid}>
            <div className={css.row}>
                {cells.pool}
                {cells.bos}
            </div>
            <div className={css.row}>
                {cells.insights}
                {cells.proxy}
                {cells.monitor}
            </div>
        </section>
    );
}
